import React, {useEffect, useState} from "react";
import Dashboard from "./Dashboard";
import MangeDashboard from "./MangeDashboard";
import Toast from "./Tost";
import './Hdash.css'
import Variz from "./Variz";
import Bardasht from "./Bardasht";
import { useMediaQuery } from 'beautiful-react-hooks';
import axios from "axios";
import CoinsVariz from "./CoinsVariz";
import CoinsBardasht from "./CoinsBardasht";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import AlertMessage from "./alertMessage";
import PageItemsDash from "./PageItemsDash";
import TopGainers from "../TopGainers";
import { Link } from "react-router-dom";
import PageAcc from "./PageAcc";
import BasicTabs from "../BasicTabs"
import LoadingAcc from "../LoadingAcc";
import LoadingTable from "../LoadingTable";
import ItemsMoreMenu from "./ItemsMoreMenu";
import MySliderShow from "./MySliderShow";
import Footer from "../Footer";
import { Flag } from "@mui/icons-material";
import { ToastContainer, toast } from 'react-toastify';




export default function Hdash(props){
    const [varizIsOpen,setVarizIsOpen] = useState(false)
    const [bardashtIsOpen,setBardashtIsOpen] = useState(false)
    const isSmall = useMediaQuery('(max-width: 768px)')
    const [symbol,setSymbol] = useState([])
    const [isLoading,setIsLoading] = useState(true)
    const [coinSelected,setCoinSelected] = useState('')
    const [coinBSelected,setCoinBSelected] = useState('')
    const [search,setSearch] = useState('')
    const [resultSym,setResultSym] = useState([])
    var  balanceC = {}
    const [balanceIR,setBalanceIR] = useState({"balance":'',"blocked":''})
    const [TeterPriceBuy,setTeterPriceBuy] = useState()
    const [TeterPriceSell,setTeterPriceSell] = useState()
    const [balanceCoin,setBalanceCoin] = useState({})
    const [varizIrIsOpen,setVarizIrIsOpen] = useState(false)
    const [bardashtIrIsOpen,setBardashtIrIsOpen] = useState(false)
    const [Messages,setMessages] = useState([
           
])
    const [isAll,setIsAll] = useState(false)
    const [result,setResult] = useState([])
    const [tabChange,setTabChange] = useState(false)
    const [key,setKey] = useState(0)

    const [loadButton ,setLoadButton] = useState(false)

    const[FavoriteCoins,setFavoriteCoins] = useState([])




    function changeToall(){
        setLoadButton(true)
        setIsAll(true)
    }




   /* useEffect(()=>{








        axios.get('https://api.sinatether.com/Auth/get_favorite_list').then((res)=>{


            if(res.status == 200){

                console.log(res.data['list_favorite'])

                setFavoriteCoins(res.data['list_favorite'])
            }
             
  
  
        })
      },[])*/






    useEffect(async()=>{

     

            
         await axios.get('https://api.sinatether.com/Auth/message/',{params:{"phone":phone},withCredentials:true}).then((res)=>{

            if (res.status == 200){



                setMessages(res.data['message'])
            

               

              

                
                
                
                
                
            }



          }).catch((error)=>{
              if(error){

              }
          })

        

        




    },[])








    let phone = sessionStorage.getItem('user')

          async function requestHandleGetBalance() {
            axios.get('https://api.sinatether.com/Auth/GetBalanceUser/', {
            params: {
                "phone": phone
            },
            withCredentials:true
            
        }).then((res) => {



            let result = res.data['userBalance']
            for (let i=0;i<result.length;i++)
            {

                //balanceCoin['BTC'] = 12

                balanceC[result[i]['nameCoin']] = result[i]['balance']
            }
            setBalanceCoin(balanceC)

            setBalanceIR(res.data['userIRbalance'])
        }).catch((error)=>{
            if(error){
                
            }
        })
          }


                 async function requestHandleGetCoin() {

                await  axios.get('https://api.sinatether.com/Auth/CoinGet/').then((res)=>{



                           if (res.status == 200)
                           {

                                            

                                            axios.get('https://api.sinatether.com/Auth/get_favorite_list').then((res)=>{


                                            if(res.status == 200){


                                                
                                                setFavoriteCoins(res.data['list_favorite'])
                                            }
                                            


                                        })

                                            setSymbol(res.data['pull'])
                                            setResult(res.data['pull'])
                                            if (flag == 0){
                                                const ress = res.data['pull'].sort(function (a, b) {
                                                    return b.changeRate - a.changeRate
                                                }) 
                                                setResult(ress)
                                               setTabChange(true)
                                               let k = Math.random()
                                                setKey(k)
                                                flag = flag + 1
                
                                            }

                                            setIsLoading(false)



                           }








         })







        }

        var flag = 0



          useEffect(async ()=>{


              await requestHandleGetBalance()




             },[])


            useEffect(async ()=>{


                 const resultInterval = () => {
                         requestHandleGetCoin()
                         setTimeout(resultInterval, 100000);



                     };
                 flag=0
                 resultInterval();




             },[])






             useEffect(() => {
                async function fetchData() {
                  // You can await here
                  const response = await axios.get('https://api.sinatether.com/Auth/GetTeter').then((res)=>{
        
                    if (res.status==200){
                         setTeterPriceBuy(res.data['teterprice']['buy'])
                         setTeterPriceSell(res.data['teterprice']['sell'])
        
                    }
        
               })
                  // ...
                }
                fetchData();
              }, []);













     function handelvariz(event) {
        setCoinSelected(event.target.value)
         setVarizIsOpen(true)
     }

     function handelbardasht(event){
        setCoinBSelected(event.target.value)
        setBardashtIsOpen(true)
     }

     function hanldleSearch(event) {
         setSearch(event.target.value)
     }

     function handleIrVariz(){
        setVarizIrIsOpen(true)
     }
     function handleIrBardasht(){
        setBardashtIrIsOpen(true)
     }







        useEffect(()=>{
   const results = symbol.filter(({symbol,persionName}) => {
          return(
              persionName.includes(search)
            ||
              symbol.includes(search.toUpperCase()))
      });

      setResultSym(results)
    },[search])


    function BalanceSpan(props){
        if(balanceCoin[props.symName] ) {
            return <span className={'text-dark '}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(balanceCoin[props.symName])}</span>
        }
        else {
            return <span className={'text-dark '}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(0)}</span>

        }
    }



    function handleTabs(value) {
        
        let k = Math.random()


         if (value === 1) {
            const res = symbol.sort(function (a, b) {
                return b.changeRate - a.changeRate
            }) 
            setResult(res)
           setTabChange(true)
                       setKey(k)


           }

           else if (value === 3) {

            const res = symbol.filter(sym => FavoriteCoins.includes(sym.symbol.split('-')[0]))
          

            
            setResult(res)
           setTabChange(true)
                       setKey(k)


           }
           else if (value === 4) {
            const res = symbol.sort(function (a, b) {
                return a.changeRate - b.changeRate
            })
            setResult(res)
           setTabChange(true)
                       setKey(k)


           }

        else if (value === 5) {
                const res = symbol.sort(function (a, b) {
                    return a.buy - b.buy
                })
                setResult(res)
            setKey(k)
            setTabChange(true)


        }
         else if (value === 0) {
                setResult(symbol)
            setTabChange(false)
                        setKey(k)


            } else if (value === 6) {
                const res = symbol.sort(function (a, b) {
                    return b.buy - a.buy
                })
                setResult(res)
                setTabChange(false)
                        setKey(k)


            } else if (value === 2) {
                const res = symbol.filter(sym => sym.type === 'leve')
                setResult(res)
                setTabChange(false)
                setKey(k)



            }



    }



    useEffect(()=>{




    },[tabChange])


    

    function handleTofavorite(event){

        let name = event.target.id

        axios.post('https://api.sinatether.com/Auth/add_to_favorite',{"coin":name}).then((res)=>{


        if (res.data['status'] == "200"){

            setFavoriteCoins(res.data['list'])
            toast.success(res.data['message'],
            {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                })
        }



        })



    }

     


    return(
        <>
            <MangeDashboard StateShowFootBalance={1}>

            {coinSelected ?
            <>
                
                <CoinsVariz modalIsOpen={varizIsOpen} Openchanger={setVarizIsOpen} coinSelected={coinSelected} coinChanger={setCoinSelected}/>
               
                </>
                :
                <></>
             }

             {coinBSelected ? 
                <CoinsBardasht modalIsOpen={bardashtIsOpen} Openchanger={setBardashtIsOpen} coinSelected={coinBSelected}  coinChanger={setCoinBSelected} />
                :
                <></>
             }
                <Variz modalIsOpen={varizIrIsOpen} Openchanger={setVarizIrIsOpen} />
                <Bardasht modalIsOpen={bardashtIrIsOpen} Openchanger={setBardashtIrIsOpen}/>


                {isSmall ?




                            <div className={"mainHpage"}>
                                 <div className="submainHpage">

                            
                        

                        </div>


                        <MySliderShow/>


                    

                                <div className="menu-items0012131">


                                    <ItemsMoreMenu  handleIrVariz={handleIrVariz} handleIrBardasht={handleIrBardasht} varizchange={setVarizIsOpen} bardashtchange={setBardashtIsOpen} coinchange={setCoinSelected} coinbchange = {setCoinBSelected} />



                                    </div>

                                    {Messages.length>0 ?

                                    <div className="content-alert">
                                        {

                                            Messages.map((mess)=>(
                                                
                                                <AlertMessage message={mess}/>
                                            ))

                                            }
                                    </div>

                                            :
                                            <></>


                                            }


                        <Tabs>
                              <TabList >
                              </TabList>

                              <TabPanel>


                               

                                   <div className="accordion mt-1 ">
                                       {isSmall?

                                                <div className="text-center fdkshjfhgge24235">

                                                <h5 className="tex-medf242">
                                                        بازار ارزهای دیجیتال

                                                </h5>



                                                </div>
                                                :

                                                <></>
                                                }

                                       <div className="row w-100 rsearch sdkjerywgrwrw2342 position-relative">
                                       <input className={'input-search text-normal'} placeholder={' جستجو ارز دیجیتال'} onChange={hanldleSearch}/>
                                       <img class="search-icon" src="https://static.sinatether.com/images/search.svg" alt="جستجو ارزهای دیجیتال"></img>

                                       </div>


                                       <div className={' pad-b12'}>
                                                        
                                                        {symbol ?

                                                            <BasicTabs handleTabs={handleTabs} isLog={true}/>
                                                            :
                                                            <></>
                                                        }

                                                    </div>




                                                    {isLoading ?
                                                        <>

                                                        <LoadingAcc/>

                                                            <LoadingAcc/>
                                                        <LoadingAcc/>
                                                            <LoadingAcc/>
                                                        <LoadingAcc/>
                                                        <LoadingAcc/>


                                                        </>

                                                        :


                                                        <>






                                       <div class="row py-2   margi-css354 "><div class="col-4 pl-4 text-large text-normal ">نام</div><div class="col-4 text-center pl-0 text-large text-normal">
                                           
                                          قیمت جهانی
                                         (تتر)

                                           
                                           </div><div class="col-4  text-large text-normal">تغییرات24h</div></div>



                                       


                                        {
                                            resultSym.length>0 && search != '' ?

                                               resultSym.map((sym) =>

                                               

                                                <div className="accordion-item">
                                                    <h2 className="accordion-header border-top py-1" id={`heading${sym['symbol']}`}>
                                                        <button className="accordion-button pl-1 pr-0 pt-0 pb-0 collapsed" type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target={`#collapse${sym['symbol']}`}
                                                                aria-expanded="true"
                                                                aria-controls={`collapse${sym['symbol']}`}>
                                                                                                                                    <img className="heart-style" id={sym['symbol'].split('-')[0]} src={`https://static.sinatether.com/images/${FavoriteCoins.includes(sym['symbol'].split('-')[0]) ? 'inheart' : 'outheart'}.svg`} onClick={handleTofavorite} />


                                                            <Link className="col-4 pointer linkStyle"
                                                               to={`/${sym['symbol'].split('-')[0]}`}>
                                                                <div className="text-black">

                                                                <img className="imgcoin "
                     src={`https://static.sinatether.com/CoinsImg/${sym['symbol'].split('-')[0]}.png`} alt={""}/>

                                                                    <span
                                                                        className="spanHeaderAcc">  <span
                                                                        className="ft-external-link text-large text-normal dis-grid">{sym['persionName']}


                                                        <span
                                                                            className="text-medium text-muted">{sym['symbol'].split('-')[0]}</span>
                                                        </span>
                                                                        
                                                                        
                                                                        
                                                                        </span>
                                               
                                                                </div>
                                                            </Link>


                                                            <div
                                                                className="col-4 pointer text-right text-blue-primery text-large priceTt"
                                                            >{new Intl.NumberFormat("fa",{maximumFractionDigits:sym['sell'] < 1 ? 13 : 3}).format(sym['sell'])}
                                                                
                                                                </div>
                                                                    <div
                                                                className="col-3 pointer text-right text-blue-primery text-large priceTt"
                                                            >

                                                            <span
                                                                className={'text-medium priceTt'}>
                                                                {sym['changeRate']>=0 ?
                                                                    <>


                                                                          <svg id="up.0f59dd92" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                                          <path id="Path_1" data-name="Path 1" d="M16,0H0V16H16Z" fill="rgba(255,255,255,0.01)"/>
                                                                          <path id="Path_2" data-name="Path 2" d="M13.668,9V5h-4" fill="none" stroke="#29cd97" stroke-width="1.333"/>
                                                                          <path id="Path_3" data-name="Path 3" d="M2,12.333,5.446,8.167l3.282,2L13.667,5" fill="none" stroke="#06a969" stroke-width="1.333"/>
                                                                        </svg>


                                                                <span className={'text-success pl-1'}>
                                                                    {sym['changeRate']}%

                                                                </span>
                                                                          </>

                                                                    :

                                                                    <>






                                                            <svg id="down.75125799" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                              <path id="Path_4" data-name="Path 4" d="M16,16H0V0H16Z" fill="rgba(255,255,255,0.01)"/>
                                                              <path id="Path_5" data-name="Path 5" d="M13.668,7v4h-4" fill="none" stroke="#f5455b" stroke-width="1.333"/>
                                                              <path id="Path_6" data-name="Path 6" d="M2,3.667,5.446,7.833l3.282-2L13.667,11" fill="none" stroke="#f5455b" stroke-width="1.333"/>
                                                            </svg>



                                                                <span className={'text-danger pl-1'}>
                                                                    {-1 * Number(sym['changeRate'])}%

                                                                </span>


                                                                    </>
                                                                }
                                                            </span>


                                                            </div>


                                                        </button>
                                                    </h2>
                                                    <div id={`collapse${sym['symbol']}`}
                                                         className="accordion-collapse collapse "
                                                         aria-labelledby={`heading${sym['symbol']}`}
                                                         data-bs-parent="#accordionExample">
                                                        <div className="accordion-body ">

                                                        <ul className={'ul-custom'}>
                            <li className={'col-6 pl-0 pr-0'}>
                                <h6 data-inline-formset={true}
                                    className={'col-12 text-success text-large text-normal  text-normal '}>
                                        <div className='text-normal phyrfjshbf'>
                                         خرید:
                                            </div> 
                                     {new Intl.NumberFormat("fa",{maximumFractionDigits:sym['BuyIrt'] > 1 ? 3 : 13}).format(sym['BuyIrt'])}
                                    <span className={' tomn242553 '}>تومان</span>
                                </h6>
                               


                            </li>

                            <li className={'col-6 pl-0 pr-0'}>
                                <h6 data-inline-formset={true} className={'col-12 text-large text-danger  text-normal content-left '}
                                >
                                    <div className='text-normal phyrfjshbf'>
                                         فروش:
                                    </div>
                                    {new Intl.NumberFormat("fa",{maximumFractionDigits:sym['sellIrt'] > 1 ? 3 : 13}).format(sym['sellIrt'])}
                                    <span className={' tomn242553'}>تومان</span>

                                </h6>
                                

                            </li>

                            

                        </ul>

                        <ul className='mb-0'>
                        <li className={'col-6 pl-0 pr-0'}>
                                <h6 data-inline-formset={true}
                                    className={'col-12 text-large text-normal  text-normal '}>
                                        
                                                                            
                                        {balanceCoin[sym['symbol'].split('-')[0]] ?
                                                                            <>

                                                                        <div className='text-normal phyrfjshbf'>
                                                                                                                موجودی:
                                                                                                                    </div> 
                                                                            <span
                                                                                className={'text-normal'}>{new Intl.NumberFormat("fa").format(balanceCoin[sym['symbol'].split('-')[0]])}</span>
                                                                            </>

                                                                            :
                                                                            <>


                                                                            <span
                                                                                className={'text-normal phyrfjshbf'}>موجودی:</span>
                                                                            <span
                                                                                className={'text-normal'}>{new Intl.NumberFormat("fa").format(0)}</span>
                                                                            </>
                                                } 
                                </h6>
                               


                            </li>
                        </ul>


                                                        


                                                            <div className="rowButton pt-3 pb-2 px-2 ">
                                                                <div className="col-3 px-1 px---1">

                                                                    <Link to={`/${sym['symbol'].split('-')[0]}`}>
                                                                    <button
                                                                        className="btn btn-success text-large w-100 py---5 buy mb-0 pointer ng-star-inserted btnsm">خرید
                                                                    </button>
                                                                    </Link>
                                                                </div>
                                                                <div className="col-3 px-1 px---1">
                                                                <Link to={`/${sym['symbol'].split('-')[0]}`}>

                                                                    <button
                                                                        className="btn btn-danger py---5 buy text-large w-100 mb-0 pointer ng-star-inserted btnsm">فروش
                                                                    </button>
                                                                    </Link>
                                                                </div>
                                                                <div className="col-3 px-1 px---1">
                                                                    <button
                                                                        className="btn btn-outline-success py---5 buy text-large w-100 pointer mb-0 btnsm text-success"
                                                                        value={sym['symbol'].split('-')[0]}
                                                                        onClick={handelvariz}>واریز
                                                                    </button>
                                                                </div>
                                                                <div className="col-3 px-1 px---1">
                                                                    <button
                                                                        className="btn btn-outline-danger py---5 buy text-large w-100 pointer mb-0 btnsm text-danger"
                                                                        value={sym['symbol'].split('-')[0]}
                                                                        onClick={handelbardasht}>برداشت
                                                                    </button>
                                                                </div>
                                                            </div>



                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                                :


                                                <>

<div className="accordion-item">
                                                    <h2 className="accordion-header border-top py-1" id={`headingIR`}>
                                                        <button className="accordion-button pl-1 pr-0 pt-0 pb-0" type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target={`#collapseIR`}
                                                                aria-expanded="true"
                                                                aria-controls={`collapseIR`}>
                                                        <img className="heart-style" id={'IR'} src={`https://static.sinatether.com/images/${FavoriteCoins.includes('IR') ? 'inheart' : 'outheart'}.svg`} onClick={handleTofavorite} />


                                                            <Link className="col-6 pointer linkStyle"
                                                               to={"#"}>
                                                                <div className="text-black">
                                                                    <img className="imgcoin "
                                                                         src={`https://static.sinatether.com/CoinsImg/IR.png`} alt={""}/>
                                                                    <span
                                                                        className="spanHeaderAcc">
                                                                              <span
                                                                        className="ft-external-link text-large text-normal dis-grid text-dark">{'تومان'}


                                                            <span
                                                    className="text-medium text-muted">{'IR'}</span>
                                                    </span>
                                                                        
                                                                        
                                                                        
                                                                        </span>
                                               
                                                                </div>
                                                            </Link>




                                                            <div
                                                                className="col-5 pointer text-right text-blue-primery text-large priceTt"
                                                            > <span
                                                                className={'text-medium priceTt'}></span></div>




                                                        </button>
                                                    </h2>
                                                    <div id={`collapseIR`}
                                                         className="accordion-collapse collapse show "
                                                         aria-labelledby={`headingIR`}
                                                         data-bs-parent="#accordionExample">
                                                        <div className="accordion-body ">


                                                            <ul className={'pt-2 mb-0'}>
                                                                <li className={'row mr-3'}>
                                                                    <h6 data-inline-formset={true}
                                                                        className={'col-9  text-normal  px-3'}>
                                                                        <div className={'text-normal phyrfjshbf'}>موجودی:</div>

                                                                         {new Intl.NumberFormat("fa").format(balanceIR.balance)}
                                                                        <span className={'tomn242553 '}>تومان</span>
                                                                    </h6>



                                                                </li>

                                                                <li className={'row pt-2'}>
                                                                    <h6 className={'col-9 text-normal text-danger px-3'}>
                                                                        <div className={'text-normal phyrfjshbf'}>بلوکه:</div>
                                                                        {new Intl.NumberFormat("fa").format(balanceIR.blocked)}
                                                                        <span className={'tomn242553 '}>تومان</span>

                                                                    </h6>

                                                                </li>

                                                            </ul>


                                                            <div className="rowButton  pb-2 px-2 ">
                                                                <div className="col-3 px-1 px---1">
                                                                </div>
                                                                <div className="col-3 px-1 px---1">

                                                                </div>
                                                                <div className="col-3 px-1 px---1">
                                                                    <button
                                                                        className="btn  py---5 btn-outline-success buy text-large w-100 pointer mb-0 btnsm text-success"
                                                                        onClick={handleIrVariz}>واریز
                                                                    </button>
                                                                </div>
                                                                <div className="col-3 px-1 px---1">
                                                                    <button
                                                                        className="btn btn-outline-danger py---5 buy text-large w-100 pointer mb-0 btnsm text-danger"
                                                                        onClick={handleIrBardasht}>برداشت
                                                                    </button>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>



                                                <div className="accordion-item">
                                                    <h2 className="accordion-header border-top py-1" id={`headingUSDT`}>
                                                        <button className="accordion-button  pl-1 pr-0 pt-0 pb-0 " type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target={`#collapseUSDT`}
                                                                aria-expanded="true"
                                                                aria-controls={`collapseUSDT`}>
                                                        <img className="heart-style" id={'USDT'} src={`https://static.sinatether.com/images/${FavoriteCoins.includes('USDT') ? 'inheart' : 'outheart'}.svg`} onClick={handleTofavorite} />


                                                            <Link className="col-6 pointer linkStyle text-white"
                                                               to={`/USDT`}>
                                                                <div className="text-black">

                                                                    <img className="imgcoin "
                                                                         src={`https://static.sinatether.com/CoinsImg/USDT.png`} alt={""}/>
                                                                    <span
                                                                        className="spanHeaderAcc">  <span
                                                                        className="ft-external-link text-large text-normal dis-grid">تـتر
                                                                        
                                                                        <span
                                                                        className="text-medium text-muted">USDT</span>
                                                                        </span>
                                                                        
                                                                        </span>
                                                
                                                                </div>
                                                            </Link>


                                                            <div
                                                                className="col-5 pointer text-right text-blue-primery text-large priceTt"
                                                            > <span
                                                                className={'text-medium priceTt'}></span></div>


                                                        </button>
                                                    </h2>
                                                    <div id={`collapseUSDT`}
                                                         className="accordion-collapse collapse show "
                                                         aria-labelledby={`headingUSDT`}
                                                         data-bs-parent="#accordionExample">
                                                        <div className="accordion-body ">


                                                            
    <ul className={'ul-custom'}>
                            <li className={'col-6 pl-0 pr-0'}>
                                <h6 data-inline-formset={true}
                                    className={'col-12 text-success text-large text-normal  text-normal '}>
                                        <div className='text-normal phyrfjshbf'>
                                         خرید:
                                            </div> 
                                            {new Intl.NumberFormat("fa").format(TeterPriceBuy ? TeterPriceBuy : '')}
                                             <span className={' tomn242553 '}>تومان</span>
                                </h6>
                               


                            </li>

                            <li className={'col-6 pl-0 pr-0'}>
                                <h6 data-inline-formset={true} className={'col-12 text-large text-danger  text-normal content-left '}
                                >
                                    <div className='text-normal phyrfjshbf'>
                                         فروش:
                                    </div>
                                    {new Intl.NumberFormat("fa").format( TeterPriceSell ? TeterPriceSell : '')}
                                    <span className={' tomn242553'}>تومان</span>

                                </h6>
                                

                            </li>

                            

                        </ul>

                        <ul className='mb-0'>
                        <li className={'col-6 pl-0 pr-0'}>
                                <h6 data-inline-formset={true}
                                    className={'col-12 text-large text-normal  text-normal '}>
                                    

                                                                            
                                            {balanceCoin['USDT'] ?
                                                                            <>

                                                                        <div className='text-normal phyrfjshbf'>
                                                                                                                موجودی:
                                                                                                                    </div> 
                                                                            <span
                                                                                className={'text-normal'}>{new Intl.NumberFormat("fa").format(balanceCoin['USDT'])}</span>
                                                                            </>

                                                                            :
                                                                            <>


                                                                            <span
                                                                                className={'text-normal phyrfjshbf'}>موجودی:</span>
                                                                            <span
                                                                                className={'text-normal'}>{new Intl.NumberFormat("fa").format(0)}</span>
                                                                            </>
                                                }                                </h6>
                               


                            </li>
                        </ul>




                                                            <div className="rowButton pt-3 pb-2 px-2 ">
                                                                <div className="col-3 px-1 px---1">
                                                                <Link to={`/USDT`}>

                                                                    <button
                                                                        className="btn btn-success text-large w-100 py---5 buy mb-0 pointer ng-star-inserted btnsm b4boxnoen">خرید
                                                                    </button>
                                                                    </Link>
                                                                </div>
                                                                <div className="col-3 px-1 px---1">
                                                                <Link to={`/USDT`}>

                                                                    <button
                                                                        className="btn btn-danger py---5 buy text-large w-100 mb-0 pointer ng-star-inserted btnsm b4boxnoen">فروش
                                                                    </button>
                                                                    </Link>
                                                                </div>
                                                                <div className="col-3 px-1 px---1">
                                                                    <button
                                                                        className="btn btn-outline-success py---5 buy text-large w-100 pointer mb-0 btnsm text-success"
                                                                        value={'USDT'}
                                                                        onClick={handelvariz}>واریز
                                                                    </button>
                                                                </div>
                                                                <div className="col-3 px-1 px---1">
                                                                    <button
                                                                        className="btn btn-outline-danger py---5 buy text-large w-100 pointer mb-0 btnsm text-danger"
                                                                        value={'USDT'}
                                                                        onClick={handelbardasht}>برداشت
                                                                    </button>
                                                                </div>
                                                            </div>



                                                        </div>
                                                    </div>
                                                </div>






                                                {result ? 

                                                <PageAcc key={key} items={result} itemsPerPage={20} balanceCoin={balanceCoin} varizchange={setVarizIsOpen} bardashtchange={setBardashtIsOpen} coinchange={setCoinSelected} coinbchange = {setCoinBSelected}  listFavorite={FavoriteCoins} setFavoriteCoins={setFavoriteCoins}/>
                                                    :
                                                    <PageAcc key={key} items={symbol} itemsPerPage={20} balanceCoin={balanceCoin} varizchange={setVarizIsOpen} bardashtchange={setBardashtIsOpen} coinchange={setCoinSelected} coinbchange = {setCoinBSelected} listFavorite={FavoriteCoins} setFavoriteCoins={setFavoriteCoins}/>

                                                }

                                                </>







                                                                    }
                                                
                                           </>     
                                              
                                        }
                                   </div>
                                 


                              </TabPanel>


                          </Tabs>


                           
                                

                            </div>





                    :

                    <>








                    <div className={'dashboardTab price-grid pb-5'}>

                     <div className="mr-5 ml-4 pt-4">
                         {Messages ? 

                                Messages.map((mess)=>(
                                    <AlertMessage message={mess}/>
                                ))

                                :
                                <></>


                         }
                            
                        

                        </div>



                        <TopGainers/>


                      
                        <Tabs>
                              <TabList >
                              </TabList>

                              <TabPanel>



                  <div className={'DesktopMainPage pt-2'}>

                      







                          <table className="table  table68 row plr-32   ">

                          <div className="text-center fdkshjfhgge24235"><h5 className="tex-medf242">بازارهای  معاملاتی</h5></div>

                          <div className="row    w-100 pl-0 pr-0 ">

                                <div className="col-6 ">

                                <div className={'pr-0 pl-0'}>
                                                    <BasicTabs handleTabs={handleTabs} isLog={true}/>

                                                            </div>
                               
                                </div>
                                <div className="col-6 text-left pt-1">
                                <div className={'search13242 '}>
                                <input className={'input-search text-large pr-4'} placeholder={'  جستجو ارز دیجیتال'} onChange={hanldleSearch}/>
                                </div>

                                </div>





                                </div>
                              <>




                               {isLoading ?
                                   <>



                          <tr className={'align-items-center text-center mt-5 pt-5 h-100'}>
                              <div className={'pt-5 mt-5 mb-5 pb-5'}>


                                  <div className={'pt-5 mt-5 mb-5 pb-5'}>


                              <i className="fa fa-spinner fa-spin loadIcon "></i>
                                  </div>

                                  </div>



                          </tr>
                                       </>


                          :



                         <>


                                                      


                                    <div className={'row   w-100 pl-1 pb-2 pt24 mborder'}>
                                                  <div className={'col-2 pt-2 pb-0 pl-0 pr-0'}>
                                                      <div className={'text-normal '}>نام</div>


                                                  </div>


                                                  <div className={'col-2  pt-2 pb-0'}>
                                                      <div className={'text-normal'}>خرید
                                                      <span className={'text-medium text-muted jhfgsfgsygdgybhete '}> تومان   </span>

                                                      </div>



                                                  </div>


                                                  <div className={'col-2  pt-2 pb-0 '}>
                                     <div className={'text-normal'}>
                                               فروش

                                               <span className={'text-medium text-muted jhfgsfgsygdgybhete '}> تومان   </span>

                                               </div>



                                                  </div>


                                                  <div className={'col-1 pt-2 pb-0'}>
                                                      <div className={'text-normal '}> جهانی
                                                      <span className={'text-medium text-muted jhfgsfgsygdgybhete '}> تتر   </span>

                                                            
                                                        </div>




                                                  </div>

                                                  
                                                  <div className={'col-2 pt-2 pb-0 text-center just-center'}>
                                                      <div className={'text-normal just-center'}>موجودی</div>


                                                  </div>


                                                  <div className={'col-2 pt-2 pb-0'}>
                                                      <span className={'text-normal text-muted'}></span>


                                                  </div>

                                              </div>


                              
                              <tbody className="p06564 pe-0">

                          



                              {resultSym.length>0 && search != '' ?
                                  resultSym.map((sym) =>

                                         
                                  <div className={'row tr_row   px-1 '}>
                                    

                                  <div className={'col-2 mt-2 d-flex'}>

                                    <img className='heart-style' id={sym['symbol'].split('-')[0]} src={`https://static.sinatether.com/images/${FavoriteCoins.includes(sym['symbol'].split('-')[0]) ? 'inheart' : 'outheart'}.svg`} onClick={handleTofavorite} />

                                                            <Link className="pointer linkStyle" to={`/${sym['symbol'].split('-')[0]}`}>
                                                                <div className="text-black">
                                                                    <img className="imgcoin "
                                                                        src={`https://static.sinatether.com/CoinsImg/${sym['symbol'].split('-')[0]}.png`} alt={""}/>
                                                                    <i className="fa-solid fa-square-up-right"></i>
                                                                    <span
                                                                        className="spanHeaderAcc">
                                                        <span
                                                        className="ft-external-link text-large">{sym['persionName']}

                                                    <span className="text-medium text-muted">{sym['symbol'].split('-')[0]}</span>

                                                        
                                                        
                                                        </span>

                                                        </span>

                                                                </div>
                                                            </Link>


                                                        </div>
                                                        {sym ?
                                                            <>

                                                        <div className={'col-2  '}>

                                                                    <div className={'mt-3 table-hover'}>
                                                                        <p className={'mt-2 text-success'}>{new Intl.NumberFormat("fa").format(sym['BuyIrt'] )} </p>
                                                                    </div>

                                                                </div>
                                                                <div className="col-2">
                                                                    <div className={'mt-3 table-hover'}>
                                                                        <p className={'mt-2 text-danger'}> {new Intl.NumberFormat("fa").format(sym['sellIrt'] )} </p>
                                                                    </div>
                                                                </div>
                                                                <div className="col-1">
                                                                    <div className={'mt-3 table-hover pl-4'}>
                                                                        <p className={'mt-2 priceTt'}> {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(sym['sell'])}</p>
                                                                    </div>
                                                                </div>


                                                            </>
                                                            :
                                                            <>


                                                              

                                                            </>


                                                        }
                                                    <div className={'col-2 text-center'}>

                                                            {balanceCoin[sym['symbol'].split('-')[0]] ?

                                                            <div className={'text-large text-dark pl-4 mt-3'}>
                                                                <span className={'text-dark'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(balanceCoin[sym['symbol'].split('-')[0]])}</span>
                                                            </div>

                                                                :

                                                            <p className={'text-large text-dark pl-4 mt-3'}>
                                                                <span className={'text-dark'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(0)}</span>
                                                            </p>

                                                            }
                                                        </div>



                                                        <div className={'col-3'}>

                                                            <div className="rowButton float-left text-right mt085 px-3 ">
                                                                <div className="col-3 px-1 px---1">
                                                                <Link to={`/${sym['symbol'].split('-')[0]}`}>
                                                                    <button
                                                                        className="btn btn-success text-large w-100 py---5 buy mb-0 pointer ng-star-inserted btnsm">خرید
                                                                    </button>
                                                                    </Link>
                                                                </div>
                                                                <div className="col-3 px-1 px---1">
                                                                <Link to={`/${sym['symbol'].split('-')[0]}`}>
                                                                    <button
                                                                        className="btn btn-danger py---5 buy text-large w-100 mb-0 pointer ng-star-inserted btnsm">فروش
                                                                    </button>
                                                                    </Link>
                                                                </div>
                                                                <div className="col-3 px-1 px---1">
                                                                    <button
                                                                        className="btn  py---5 buy text-large w-100 pointer mb-0 btnsm btn-outline-success"
                                                                        value={sym['symbol'].split('-')[0]}
                                                                        onClick={handelvariz}>واریز
                                                                    </button>
                                                                </div>
                                                                <div className="col-3 px-1 px---1">
                                                                    <button
                                                                        className="btn btn-outline-danger py---5 buy text-large w-100 pointer mb-0 btnsm btn-outline-danger text-danger mr-3"
                                                                        value={sym['symbol'].split('-')[0]}
                                                                        onClick={handelbardasht}>برداشت
                                                                    </button>
                                                                </div>
                                                            </div>


                                                        </div>

                                                        </div>
                                      
                                  )
                                  :


                                  <>

                            <div className={'row tr_row  px-1 '}>
                                                              <div className={'col-2 mt-2 d-flex'}>
                                                              <img className='heart-style' id={'IR'} src={`https://static.sinatether.com/images/${FavoriteCoins.includes('IR') ? 'inheart' : 'outheart'}.svg`} onClick={handleTofavorite} />

                                                                  <Link className="pointer linkStyle"
                                                                     to={`#`}>
                                                                      <div className="text-black">
                                                                          <img className="imgcoin "
                                                                               src={`https://static.sinatether.com/CoinsImg/IR.png`} alt={""}/>
                                                                          <span
                                                                              className="spanHeaderAcc">
                                         <span
                                             className="ft-external-link tt0562 text-large">
                                                 تومان

                                                 <span className="text-medium text-muted">IR</span>

                                                 
                                                 </span>

                                    </span>

                                                                      </div>
                                                                  </Link>


                                                              </div>

                                                                      <div className={'col-2 '}>
                                                                          <div className={'mt-3 table-hover'}>
                                                                              <p className={'mt-2 text-success'}></p>
                                                                          </div>

                                                                      </div>
                                                                      <div className={'col-2 '}>
                                                                          <div className={'mt-3 table-hover'}>
                                                                              <p className={'mt-2 text-danger'}></p>
                                                                          </div>
                                                                      </div>
                                                                      <div className={'col-1 '}>
                                                                          <div className={'mt-3 table-hover'}>
                                                                              <p className={'mt-2 m0562 priceTt'}></p>
                                                                          </div>
                                                                      </div>

                                                                      <div className={'col-2 text-center '}>
                                                                          <div className={' mt-3 table-hover'}>
                                                                              <p className={'mt-2 priceTt'}>


                                                                              <div className={'text-large mt-3 text-dark pl-4 mt-3'}>
                                                                             <span className={'text-dark'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(balanceIR['balance'])}</span>
                                                                                  </div>



                                                                              </p>
                                                                          </div>
                                                                      </div>


                                                              <div className={'col-3  '}>


                                                              <div className="rowButton  text-right mt085 px-3 ">
                                                  <div className="col-3 px-1 px---1">
                                                  </div>
                                                  <div className="col-3 px-1 px---1">

                                                  </div>
                                                  <div className="col-3 px-1 px---1">
                                                      <button
                                                          className="btn  py---5 buy text-large w-100 pointer mb-0 btnsm btn-outline-success"

                                                          onClick={handleIrVariz}>واریز
                                                      </button>
                                                  </div>
                                                  <div className="col-3 px-1 px---1">
                                                      <button
                                                          className="btn  py---5 buy text-large w-100 pointer mb-0 btnsm btn-outline-danger text-danger mr-3"
                                                          onClick={handleIrBardasht}>برداشت
                                                      </button>
                                                  </div>
                                              </div>

                                             



                                                              </div>

                                </div>


                              
                                <div className={'row tr_row  px-1 '}>
                                                              <div className={'col-2 mt-2 d-flex '}>
                                                              <img className='heart-style' id={'IR'} src={`https://static.sinatether.com/images/${FavoriteCoins.includes('IR') ? 'inheart' : 'outheart'}.svg`} onClick={handleTofavorite} />

                                                                  <Link className="pointer linkStyle"
                                                                     to={`/USDT`}>
                                                                      <div className="text-black">
                                                                          <img className="imgcoin "
                                                                               src={`https://static.sinatether.com/CoinsImg/USDT.png`} alt={""}/>
                                                                          <span
                                                                              className="spanHeaderAcc">
                                         <span
                                             className="ft-external-link tt0562 text-large">
                                                 تـتر

                                                 <span className="text-medium text-muted">USDT</span>

                                                 
                                                 </span>

                                    </span>

                                                                      </div>
                                                                  </Link>


                                                              </div>
                                                              {TeterPriceBuy ?
                                                                  <>

                                                                      <div className={'col-2 '}>
                                                                          <div className={'mt-3 table-hover'}>
                                                                              <p className={'mt-2 text-success'}>{new Intl.NumberFormat("fa").format(TeterPriceBuy)} </p>
                                                                          </div>

                                                                      </div>
                                                                      <div className={'col-2 '}>
                                                                          <div className={'mt-3 table-hover'}>
                                                                              <p className={'mt-2 text-danger'}> {new Intl.NumberFormat("fa").format(TeterPriceSell)} </p>
                                                                          </div>
                                                                      </div>
                                                                      <div className={'col-1 '}>
                                                                          <div className={'mt-3 table-hover'}>
                                                                              <p className={'mt-2 priceTt'}></p>
                                                                          </div>
                                                                      </div>

                                                                      <div className={'col-2 text-center '}>
                                                                          <div className={'mt-3 table-hover'}>
                                                                              <p className={'mt-2 priceTt pl-4'}>


                                                                              <BalanceSpan symName={'USDT'}/>




                                                                              </p>
                                                                          </div>
                                                                      </div>


                                                                  </>
                                                                  :
                                                                  <>


                                                                      

                                                                  </>


                                                              }


                                                              <div className={'col-3  '}>

                                                              <div className="rowButton float-left text-right mt085 px-3 ">
                                                  <div className="col-3 px-1 px---1">
                                                    <Link to="/USDT">

                                                      <button
                                                          className="btn btn-success text-large w-100 py---5 buy mb-0 pointer ng-star-inserted btnsm b4boxnoen">خرید
                                                      </button>
                                                      </Link>
                                                  </div>
                                                  <div className="col-3 px-1 px---1">
                                                    <Link to="/USDT">
                                                      <button
                                                          className="btn btn-danger py---5 buy text-large w-100 mb-0 pointer ng-star-inserted btnsm b4boxnoen">فروش
                                                      </button>
                                                    </Link>
                                                  </div>
                                                  <div className="col-3 px-1 px---1">
                                                      <button
                                                          className="btn  py---5 buy text-large w-100 pointer mb-0 btnsm btn-outline-success"
                                                          value={'USDT'}

                                                          onClick={handelvariz}>واریز
                                                      </button>
                                                  </div>
                                                  <div className="col-3 px-1 px---1">
                                                      <button
                                                          className="btn  py---5 buy text-large w-100 pointer mb-0 btnsm btn-outline-danger text-danger mr-3"
                                                          value={'USDT'}
                                                          onClick={handelbardasht}>برداشت
                                                      </button>
                                                  </div>
                                              </div>



                                                              </div>

                                </div>





                                

                                  <PageItemsDash key={key} items={result} itemsPerPage={20} balanceCoin={balanceCoin} varizchange={setVarizIsOpen} bardashtchange={setBardashtIsOpen} coinchange={setCoinSelected} coinbchange = {setCoinBSelected} FavoriteCoins={FavoriteCoins} setFavoriteCoins={setFavoriteCoins}/>
                                    
                                    </>

                                  






                                  



                                  

                                  



                                  
 
                                  
                                  
                                  


                              }


                              </tbody>

                                                       </>


                              }

                              </>

                          </table>



                      </div>
                              </TabPanel>
                          </Tabs>




                    </div>
                                              <Footer />

                                              </>



                }





            </MangeDashboard>







        </>
    )
}